import React from "react";
import BaseTimeSeriesWidgetRO from "../base-widgets/BaseTimeSeriesWidgetRO";
import { LubeHistoryWidget as LubeHistoryWidgetComponent } from "../../../components/widgets";

const DEFAULT_TIMEFRAME = {
  type: "moving",
  "length.value": 180,
  "length.units": "days",
  "interval.type": "set",
  "interval.value": 30,
  "interval.units": "seconds",
};

const LubeHistoryWidget = (props) => {
  return (
    <BaseTimeSeriesWidgetRO
      {...props}
      defaultTimeframe={DEFAULT_TIMEFRAME}
      fixedWindow={true}
    >
      {(baseProps) => (
        <LubeHistoryWidgetComponent
          {...baseProps}
          defaultTimeframe={DEFAULT_TIMEFRAME}
        />
      )}
    </BaseTimeSeriesWidgetRO>
  );
};

export default LubeHistoryWidget;
